"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateNumberOfNotesOnlySessions(aggregatedStat, sessionEvent) {
    return aggregatedStat.numberOfNotesOnlySessions + 1;
}
exports.default = updateNumberOfNotesOnlySessions;
